import { Component, Input } from '@angular/core'
import {
  NgClass,
  NgStyle,
  NgSwitch,
  NgSwitchCase,
  NgSwitchDefault,
} from '@angular/common'

@Component({
  standalone: true,
  imports: [NgClass, NgStyle, NgSwitch, NgSwitchCase, NgSwitchDefault],
  selector: 'app-custom-icons',
  templateUrl: './custom-icons.component.html',
})
export class CustomIconsComponent {
  @Input() iconName: string
  @Input() width: string = '22'
  @Input() height: string = '22'
  @Input() className: string

  public src: string
}
